module.exports = __webpack_public_path__ + "static/media/Pr1.fafb5358.png";